
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PatientKins',
  props: ['patient'],
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        title: 'First Name',
        align: 'start',
        sortable: false,
        key: 'firstName',
      },
      { title: 'Middle Name', key: 'middleName' },
      { title: 'Last Name', key: 'lastName' },
      { title: 'Contact', key: 'contact' },
      { title: 'Relationship', key: 'relationship' },
      { title: 'Actions', key: 'actions', sortable: false },
    ],
    patientKins: [],
    editedIndex: -1,
    editedItem: {
      firstName: '',
      middleName: '',
      lastName: '',
      contact: '',
      relationship: ''
    },
    defaultItem: {
      firstName: '',
      middleName: '',
      lastName: '',
      contact: '',
      relationship: ''
    },
  }),

  computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add New Next of Kins' : 'Edit Next of Kins'
      },
    },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  created () {
    if (!this.patient){
      return
    }
    this.initialize()
  },
  methods: {
    initialize () {
      this.patientKins = [
        {
          firstName: 'Cherry',
          middleName: 'Pie',
          lastName: 'Shortcake',
          contact: '123957125',
          relationship: 'Sister'
        },
        {
          firstName: 'Raspberry',
          middleName: 'Pie',
          lastName: 'raspberyy.pie@somepie.com',
          relationship: 'Father'
        }
      ]
    },

    editItem (item) {
      this.editedIndex = this.patientKins.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.patientKins.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.patientKins.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.patientKins[this.editedIndex], this.editedItem)
      } else {
        this.patientKins.push(this.editedItem)
      }
      this.close()
    },
  },
})
